import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Llevo 2 semanas usándolo y ya no me quedo hasta tarde planificando. Mis domingos son míos otra vez.',
  name: 'Sofía V.',
  role: 'Inicial, Perú'
}, {
  quote: 'Lo mejor es que los niños responden solos a las rutinas visuales. Ya no necesito repetir las instrucciones 10 veces.',
  name: 'Daniela P.',
  role: 'Jardín, Argentina'
}, {
  quote: 'Pensé que era otro PDF más… pero esto es un sistema completo. Cada tomo tiene sentido y se conecta con el siguiente.',
  name: 'Gabriela S.',
  role: 'Preescolar, Colombia'
}, {
  quote: 'Mi directora me felicitó por la organización de mis clases. Todo gracias al MegaPack. ¡No exagero!',
  name: 'Fernanda L.',
  role: 'Kínder, México'
}, {
  quote: 'Soy mamá y maestra. Este material me devolvió tiempo con mi familia. Lo recomiendo de corazón.',
  name: 'Claudia M.',
  role: 'Inicial, Ecuador'
}, {
  quote: 'Las actividades son tan claras que hasta mi auxiliar puede aplicarlas sin que yo esté presente.',
  name: 'Verónica R.',
  role: 'Jardín, Chile'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-287">
      <div className="max-w-xl mx-auto" data-id="element-288">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-2" data-id="element-289">
          🗣️ Maestras reales, resultados reales
        </h2>
        <p className="text-sm text-gray-500 text-center mb-8" data-id="element-290">
          Esto dicen quienes ya aplican el sistema en su aula
        </p>

        <div className="space-y-3" data-id="element-291">
          {comments.map((c, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-4 rounded-xl" data-id="element-292">
              <div className="flex gap-0.5 mb-2" data-id="element-293">
                {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-yellow text-brand-yellow" data-id="element-294" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-2 leading-relaxed" data-id="element-295">
                "{c.quote}"
              </p>
              <div className="flex items-center gap-2" data-id="element-296">
                <div className="w-7 h-7 rounded-full bg-gray-700 flex items-center justify-center text-xs font-bold text-brand-yellow flex-shrink-0" data-id="element-297">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-298">
                  <p className="font-bold text-white text-xs" data-id="element-299">{c.name}</p>
                  <p className="text-[11px] text-gray-500" data-id="element-300">{c.role}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}